<div class="bn-single-card-content">
  <div class="bn-single-card-content__wrapper">
    <div class="bn-single-card-content__header d-flex">
      @if (iconName && !showSkeleton) {
        <fa-icon
          class="bn-single-card-content__icon"
          [icon]="['fad', iconName]" />
      }
    </div>
    @if (heading) {
      <div class="bn-single-card-content__heading">
        @if (!showSkeleton) {
          <span [title]="heading">
            {{ heading }}
          </span>
        }
        <span>
          @if (showSkeleton) {
            <ng-template [ngTemplateOutlet]="basicSkeleton" />
          }
        </span>
      </div>
    }
    <ng-template [ngTemplateOutlet]="cardContent" />
  </div>
  <a
    class="bn-card__overlay-link bn-single-card-content__link"
    [routerLink]="itemId ? itemId : undefined">
  </a>
  <div class="bn-single-card-content__more-link">
    @if (!showSkeleton) {
      <bn-web-ui-dropdown-menu
        class="bn-table__bn-action-dropdown text-start"
        [items]="dropdownMenuItems ?? []"
        [options]="overridenDropdownMenuOptions"
        (clickAction)="onDropdownMenuClick($event, itemId)">
        <span
          class="bn-table__bn-dropdown-trigger"
          trigger>
          <fa-icon icon="ellipsis" />
        </span>
      </bn-web-ui-dropdown-menu>
    }
  </div>
</div>

<ng-template #cardContent>
  <ng-content />
</ng-template>

<ng-template #basicSkeleton>
  <ngx-skeleton-loader
    animation="progress"
    [theme]="{ 'width.%': 40, 'height.px': 25, 'margin-bottom.px': 10 }" />
</ng-template>
